import type { CSSProperties } from "react";

/**
 * create an array of display types so that it can be looped over and then
 * create the property type from this array
 */
export const buiAvatarColorize = [
  "default",
  "red",
  "orange",
  "yellow",
  "green",
  "teal",
  "blue",
  "indigo",
  "purple",
  "pink",
] as const;

export const buiAvatarSizes = ["xs", "sm", "md", "lg"] as const;

export const buiAvatarIconNames = ["User", "InternalUsers", "People"] as const;

/**
 * Bui Avatar display types created from array which is used for any looping
 */
export type TBuiAvatarColorize = (typeof buiAvatarColorize)[number];
export type TBuiAvatarSizes = (typeof buiAvatarSizes)[number];
export type TBuiAvatarIconNames = (typeof buiAvatarIconNames)[number];

export interface BuiAvatarProps {
  /**
   * Id applied to the rendered tag.
   */
  id?: string;
  /**
   * data-testid applied to the rendered tag for testing purposes.
   */
  testid?: string;
  /**
   * Provide the full name.
   * Full name will be converted to initials. This can handle multi name and hyphenated names.
   * @default undefined
   */
  text?: string;
  /**
   * Provide the src location of an image file
   * if you would like an image display
   * @default undefined
   */
  src?: string;
  /**
   * Provide the size of the Avatar display in pixels
   */
  // sizeInPx?: number; // Add if we find we need to allow for any size to be used
  /**
   * Provide the size of the Avatar display in pixels
   * @default "xs"
   */
  size?: TBuiAvatarSizes; // Add if we find we need to allow for any size to be used
  /**
   * Acts as a reference to the icon you want to use and is
   * crucial for rendering the correct icon.
   * @default "User"
   */
  iconName?: TBuiAvatarIconNames;
  /**
   * Select a defined colorized color to use
   * only for initials display.
   * Note legacy colors can still be passed with `style` values for background and color;
   * @default "default"
   */
  colorize?: TBuiAvatarColorize;
  /**
   * The className attribute for the BuiAvatar.
   * @default undefined
   */
  className?: string;
  /**
   * The style attribute for the BuiAvatar.
   * @default undefined
   */
  style?: CSSProperties;
}
